/**
 * @description Примесь поиска услуги.
 * @type {any}
 */
export default {
  computed: {
    /**
     * @description Услуги.
     * @type {ServiceItem[]}
     */
    services({
      selectedServices,
      favoriteServices,
      serviceList,
      searchServiceQuery,
      initialServices,
    }) {
      const searchQueryIsNotEmpty = !!searchServiceQuery && searchServiceQuery.length >= 0;
      const showAll = favoriteServices.length === 0 || searchQueryIsNotEmpty;
      const list = showAll ? serviceList : favoriteServices;
      const mix = initialServices?.length
        ? selectedServices.concat(initialServices)
        : selectedServices;
      return mix.concat(list);
    },
    /**
     * @description Начальные услуги.
     * @type {ServiceItem[]}
     */
    selectedServices: () => [],
  },
  data() {
    return {
      /**
       * @description Поисковой запрос услуги.
       * @type {string}
       */
      searchServiceQuery: '',
    };
  },
  methods: {
    /**
     * @description Отчистить строку поиска.
     * @returns {void}
     */
    clearSearchQuery() {
      this.searchServiceQuery = '';
    },
    /**
     * @description Обработать обновление строки поиска услуги.
     * @param {string} value
     * @returns {void}
     */
    onUpdateServiceQuery(value) {
      this.searchServiceQuery = value;
    },
  },
  props: {
    /**
     * @description Список услуг.
     * @type {any[]}
     */
    serviceList: { type: Array, required: true },
    /**
     * @description Список избранных услуг.
     * @type {ServiceItem[]}
     */
    favoriteServices: {
      default: () => [],
      type: Array,
    },
  },
};
